import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate, style = "text-center" }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        dias: Math.floor(difference / (1000 * 60 * 60 * 24)),
        horas: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutos: Math.floor((difference / 1000 / 60) % 60),
        segundos: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  return (
    <div className={style}>
      <div className="flex justify-center space-x-4 flex-wrap">
        {Object.keys(timeLeft).length ? (
          Object.entries(timeLeft).map(([unit, value]) => {
            const isSeconds = unit === 'segundos';
            const unitClass = isSeconds ? 'hidden md:flex' : 'flex';

            return (
              <div
                key={unit}
                className={`${unitClass} group shadow-sm rounded-md md:px-7 md:py-3 cursor-pointer pb-2 flex-col justify-center md:w-40 items-center space-y-1 active:scale-95`}
              >
                <div className="md:text-2xl font-semibold uppercase group-hover:text-yellow-300 pb-2 text-[#82ecfc]">
                  {unit}
                </div>
                <div className="md:text-7xl font-semibold text-white">
                  {value}
                </div>
              </div>
            );
          })
        ) : (
          <div className="p-4 bg-red-500 text-white rounded-lg">
            <div className="text-2xl">¡Se terminó!</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CountdownTimer;
